import { styled } from '@mui/material/styles'
import { FC, memo } from 'react'
import { useDispatch } from 'react-redux'
import { updateDepositModalOption } from 'store/deposit/actions'
import { DepositModalOption } from 'store/deposit/types'
import { ContentWrap, Flex, Space16 } from 'styles'
import { Box, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ReactComponent as IconWallet } from './assets/wallet.svg'
import { ReactComponent as IconQrcode } from './assets/qrcode.svg'
import { IconInfo } from 'components/Icons'

const Wrap = styled(ContentWrap)``

export const DepositTip = styled(Stack)`
  gap: 8px;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  line-height: 18px;
  color: rgba(149, 164, 173, 1);

  svg {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
  }
`
export const DepositTypeListWrap = styled(Stack)`
  gap: 16px;
`
export const DepositTypeOption = styled(Box)`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 18px;
  align-items: center;
  padding: 16px;
  line-height: 1.4;
  color: ${(props) => props.theme.color.text90};
  background-color: rgba(22, 25, 30, 1);
  border-radius: 6px;

  border-left: 2px solid transparent;
  transition: border 0.1s ease;
  cursor: pointer;

  &:hover {
    background-color: rgba(42, 49, 57, 1);
    border-color: rgba(160, 238, 9, 1);
  }
`
export const DepositTypeOptionTitle = styled(Flex)`
  font-weight: 600;
  font-size: 16px;
`
export const DepositTypeOptionDescribe = styled(Flex)`
  color: rgba(149, 164, 173, 1);
  font-weight: 400;
  font-size: 14px;
  margin-top: 8px;
`
export const DepositSelectOption = memo(() => {
  const dispatch = useDispatch()
  return (
    <Wrap>
      <DepositTip>
        <IconInfo />
        <div>
          All ZKEX Testnet tokens are for testing, they are not real wrapped
          tokens. Note: For all deposits, you will need to pay network gas fees
          for the origin chain.
        </div>
      </DepositTip>
      <Space16 />
      <DepositTypeList
        onSelectOption={(option) => {
          dispatch(updateDepositModalOption(option))
        }}
      />
    </Wrap>
  )
})

export const DepositTypeList: FC<{
  onSelectOption: (option: DepositModalOption) => void
}> = memo(({ onSelectOption }) => {
  const { t } = useTranslation()
  return (
    <DepositTypeListWrap>
      <DepositTypeOption
        onClick={() => {
          onSelectOption(DepositModalOption.SelectAssets)
        }}
      >
        <IconWallet />
        <Stack>
          <DepositTypeOptionTitle>
            {t('deposit-option-1-title')}
          </DepositTypeOptionTitle>
          <DepositTypeOptionDescribe>
            {t('deposit-option-1-describe')}
          </DepositTypeOptionDescribe>
        </Stack>
      </DepositTypeOption>
      <DepositTypeOption
        onClick={() => {
          onSelectOption(DepositModalOption.Qrcode)
        }}
      >
        <IconQrcode />
        <Stack>
          <DepositTypeOptionTitle>
            {t('deposit-option-2-title')}
          </DepositTypeOptionTitle>
          <DepositTypeOptionDescribe>
            {t('deposit-option-2-describe')}
          </DepositTypeOptionDescribe>
        </Stack>
      </DepositTypeOption>
    </DepositTypeListWrap>
  )
})
